
import React, { useState, useEffect } from "react";
import { MapContainer , Marker, Popup, TileLayer} from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet.markercluster';
import ClipLoader from 'react-spinners/ClipLoader';

function MarkersMap({TransportMeansSelection}) {

    const [markers, setMarkers] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state


    let url = "";
    var MeansOfTransport = "";

   
    switch (TransportMeansSelection[0]) {
        case 'Οδικές':
          url = '/api/roadtransport/position'
          MeansOfTransport = "Airport"
          
          break;
        case 'Αεροπορικές':
          url = '/api/airtransport/position'
          MeansOfTransport = "Airport"
          
          break;
        case 'Θαλάσσιες':
          url = "/api/marinetransport/position";
          MeansOfTransport = "Port"
          break;
        case 'Σιδηροδρομικές':
          url = '/api/railtransport/position';
          MeansOfTransport = "TSName"
        break;
        default:
          console.log('I do not recognize this fruit.');
      }

    useEffect(() => {
      setLoading(true); // Start loading
        fetch(url).then((res) =>
           res.json().then((res) => {
         
            var dataTable = []

            res.data.map((obj, i) => (
                dataTable.push({id : obj["ID"],name: obj[MeansOfTransport], position: [obj.Coordinates[0][1], obj.Coordinates[0][0]]})
            ));
            setMarkers(dataTable)
            setLoading(false); // Stop loading once data is fetched
          })
        )
        .catch((error) => {
          console.log("Refetching data for Markers!")
        });
      }, [url,MeansOfTransport]);


  const center = [39.0742, 21.8243];
  const zoom = 7;

  const defaultIcon = L.icon({
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
  });

  const iconCreateFunction = function(cluster) {
    const count = cluster.getChildCount();
  
    const size =
      count < 10 ? 40 :
      count < 100 ? 45 :
      count < 1000 ? 50 :
      55;
  
    return L.divIcon({
      html: `<div style="background-color: blue; border-radius: 50%; width: ${size}px; height: ${size}px; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold;">${count}</div>`,
      className: 'marker-cluster-custom'
    });
  };
  

  if(!loading) {
    return (

      <div className = "container" style = {{marginBottom: "5%"}}>
            <p style = {{color: "orange"}}>*Για περισσότερες πληροφορίες πατήστε πάνω στην πινέζα.</p>
          
        
          <MapContainer
          center={center}
          zoom={zoom}
          //SOS It MUST HAVE STATIC HEIGHT IN ORDER TO SHOW
          style={{ height: "600px", width: "100%" }}
          >
              <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              
            <MarkerClusterGroup  iconCreateFunction={iconCreateFunction}
          icon={defaultIcon}>
                {markers.map(marker => (
                  <Marker key={marker.id} position={marker.position} icon={defaultIcon}>
                    <Popup>
                      <div>
                        {TransportMeansSelection[0] === "Οδικές"? <></>: <p>Ονομασία: {marker.name}</p>}
                        <p>ID: {marker.id}</p>
                        <p>Χ συντεταγμένη: {marker.position[1].toFixed(2)}</p>
                        <p>Υ συντεταγμένη: {marker.position[0].toFixed(2)}</p>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MarkerClusterGroup>
          </MapContainer>
      </div>
      );
    }else {
      return(
      <div className="container" style = {{marginLeft: "40%"}}>
        <ClipLoader size={100} color={'#123abc'} loading={true}/>
      </div>)
    }
    
  
}

export default MarkersMap;
